
// Public (pre-auth) route constants only.
// Protected feature paths moved to protected-app.routes.ts for lazy loading.
export const APP_ROUTES = {
  LOGIN: '/login',
  HOME: '/home', // kept for redirect convenience
};

// Barrel re-export kept for compatibility
export * from './routes';
